// extracted by mini-css-extract-plugin
export default {"navegacao":"Menu_navegacao__iq-YB","link":"Menu_link__a+fQi","linkDestacado":"Menu_linkDestacado__RjZev"};